import * as React from 'react';
import Logo from '../assets/images/logo.svg'

const ErrorFallback = () => {
    return (
        <div className='d-flex align-items-center justify-content-around'>
            <p>Something went wrong.</p>
            <img
                src={Logo}
                alt="Error Fallback"
                style={{
                    objectFit: 'contain',
                    width: '80%',
                    height: '80%',
                }}
            />
        </div>
    );
}

export default ErrorFallback;